module.exports = __webpack_public_path__ + "img/boleto.69236a7.png";